export default {
  getAuthError: state => state.authError,
  getPopupType: state => state.popupType,
  getCurrentPhone: state => state.currentPhone,
  getIsPopup: state => state.isPopup,
  getRegError: state => state.regError,
  getSavePhone: state => state.savePhone
}



// WEBPACK FOOTER //
// ./src/components/store/modules/auth/getters.js